<template>
  <div class="mask" v-if="show">
    <div class="wrapper">
      <div class="headline">
        <p class="title">
          {{`设备外借`}}
        </p>
        <img src="../assets/img/resources/close.svg" alt="close" class="close" @click="close()">
      </div>
      <div class="inputer">
        <input type="text" :placeholder="`请输入设备编号`" v-model="device.string" disabled="true">
      </div>
      <div class="detail">
        <div class="item">
          <span class="required"></span>
          <span class="name">借用人</span>
          <span class="input">
            <input type="text" v-model="info.user">
          </span>
        </div>
        <div class="item">
          <span class="name">联系电话</span>
          <span class="input">
            <input type="text" v-model="info.tel">
          </span>
        </div>
        <div class="item" >
          <span class="required"></span>
          <span class="name">外出地点</span>
          <span class="input">
            <input type="text" v-model="info.locate" placeholder="请填写地点">
          </span>
        </div>
        <div class="item">
          <span class="required"></span>
          <span class="name">所属部门</span>
          <span class="input">
            <input type="text" v-model="info.department" placeholder="请填写部门">
          </span>
        </div>
        <div class="item long">
          <span class="required">*</span>
          <span class="name">外借主题</span>
          <span class="input">
            <input type="text" v-model="info.topic">
          </span>
        </div>
        <div class="item long">
          <span class="required">*</span>
          <span class="name">外借时间</span>
          <date-picker v-model="datePicker" range placeholder="    开始时间    ～    结束时间" calendar-icon="none" :editable="false" :clearable="false" :shortcuts="false" confirm></date-picker>
        </div>
      </div>
      <div class="remark">
        <textarea placeholder="备注" v-model="info.remark" maxlength="200">
        </textarea>
        <span class="count">{{`${info.remark.length}/200`}}</span>
      </div>
      <div class="btn" @click="postMsg()">
        外借
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import common from '@common/common'
import {apis} from '@common/config'

export default {
  name: 'equipmentLoan',
  components: {
    DatePicker
  },
  watch: {
    datePicker: {
      deep: true,
      handler: function(n) {
        this.info.starttime = common.stampToTime(n[0])
        this.info.endtime = common.stampToTime(n[1])
      }
    }
  },
  data() {
    return {
      show: false,
      datePicker: '',
      device: {
        id: '',
        name: ''
      },
      info: {
        // number: '',
        user: '',
        tel: '',
        locate: '',
        topic: '',
        starttime: '',
        endtime: '',
        remark: '',
        department: ''
      }
    }
  },
  methods: {
    open(l) {
      // 打开弹窗
      this.device.id = l.id
      this.device.name = l.title
      this.device.string = l.string
      this.show = true
    },
    close() {
      // 关闭弹窗
      this.show = false
    },
    postMsg() {
      // 提交外借数据
      const device_id = this.device.id
      const device_name = this.device.name
      const borrow_username  = this.info.user
      const phone = this.info.tel
      const address = this.info.locate
      const depart_name = this.info.department
      const title = this.info.topic
      const start = this.info.starttime
      const end = this.info.endtime
      const start_remark = this.info.remark

      const info = {
        device_id: device_id,
        device_name: device_name,
        borrow_username: borrow_username,
        phone: phone,
        address: address,
        depart_name: depart_name,
        title: title,
        start: start,
        end: end,
        start_remark: start_remark
      }

      common.myFetch(apis.Res_device_borrow, info)
      .then((data) => {
        if (data) {
          this.$toast(data)
          this.close()
        }
      })
    }
  },
  mounted() {

  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/global.less';

.mask {
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  position: fixed;
  z-index: 1001;
  background-color: rgba(0,0,0,0.70);
  display: flex;
  align-items: center;
  justify-content: center;
  .wrapper {
    .boxOuter;
    width: 680px;
    height: auto;
    padding: 20px 30px;
    .headline {
      height: 34px;
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      .title {
        font-size: 24px;
        color: @dark;
        font-weight: bold;
      }
      .close {
        cursor: pointer;
      }
    }
    .inputer {
      height: 40px;
      border-radius: 4px;
      background-color: rgba(185, 195, 195, 0.2);
      display: flex;
      padding: 10px 20px;
      margin-bottom: 13px;
      input {
        background-color: transparent;
        flex: 1;
        font-size: 14px;
        color: @dark;
        &::placeholder {
          color: @dateColor;
          font-size: 14px;
        }
      }
    }
    .detail {
      padding-bottom: 7px;
      border-bottom: 1px solid #dcdcdc;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      .item {
        width: 50%;
        margin: 13px 0;
        height: 30px;
        display: flex;
        align-items: center;
        .required {
          color: @red;
          width: 10px;
          font-size: 24px;
          font-family: Helvetica, sans-serif;
          margin-right: 10px;
        }
        .name {
          width: 52px;
          font-size: 14px;
          color: @sub;
          text-align-last: justify;
          margin-right: 30px;
          word-break: keep-all;
        }
        .input {
          box-sizing: border-box;
          width: 180px;
          height: 30px;
          border-radius: 4px;
          border: 1px solid #dcdcdc;
          padding-left: 38px;
          font-size: 14px;
          color: @dark;
          display: flex;
          align-items: center;
          overflow: hidden;
          select {
            font-size: 14px;
            height: 100%;
            flex: 1;
            border: none;
            outline: none;
          }
          input {
            font-size: 14px;
            height: 100%;
            flex: 1;
            box-sizing: border-box;
            background-color: transparent;
            &::placeholder {
              color: @dateColor;
            }
          }
          .down {
            margin: 0 10px;
          }
        }
      }
      .item:nth-child(2n) {
        justify-content: flex-end;
      }
      .long {
        width: 100% !important;
        justify-content: flex-start !important;
        .input {
          width: 100%;
        }
      }
    }
    .remark {
      height: 200px;
      border-radius: 4px;
      border: 1px solid #dcdcdc;
      margin: 20px 0;
      padding: 14px 20px 28px;
      position: relative;
      textarea {
        width: 100%;
        height: 100%;
        background-color: transparent;
        resize: none;
        font-size: 16px;
        color: @dark;
        &::placeholder {
          color: @dateColor;
        }
      }
      .count {
        font-size: 16px;
        color: @dateColor;
        bottom: 8px;
        right: 18px;
        position: absolute;
      }
    }
    .btn {
      width: 120px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-radius: 100px;
      background-color: @green;
      color: #fff;
      font-size: 14px;
      margin: 0 auto;
      cursor: pointer;
      &:hover {
        .btnHover;
      }
      &:active {
        .btnActive;
      }
    }
  }
}
</style>
